let $slider = document.querySelector('.js-slider')

if ($slider) init($slider)

function init ($slider) {
  let preventClick = false

  import(/* webpackChunkName: 'flickity' */ 'flickity').then(Flickity => {
    let flkty = new Flickity($slider, {
      cellAlign: 'center',
      contain: true,
      prevNextButtons: false,
      wrapAround: true
    })

    flkty.on('staticClick', (e, pointer, element, index) => {
      if (index !== flkty.selectedIndex) {
        preventClick = true
        window.setTimeout(() => {
          preventClick = false
        }, 0)
        flkty.select(index)
      }
    })

    $slider.addEventListener('click', e => {
      let $link = e.target.closest('a')
      if (!$link) return
      if (preventClick) {
        e.preventDefault()
      }
    })

    let $controls = $slider.getAttribute('data-controls')
    if ($controls) {
      $controls = Array.from(
        document.getElementById($controls).querySelectorAll('a')
      )

      $controls.forEach(($control, i) => {
        $control.addEventListener('click', e => {
          e.preventDefault()
          flkty.select(i)
        })
      })

      flkty.on('select', () => {
        $controls
          .filter($control => $control.classList.contains('is-active'))[0]
          .classList.remove('is-active')

        $controls[flkty.selectedIndex].classList.add('is-active')
      })
    }
  })
}



// WEBPACK FOOTER //
// ./src/js/_slider.js